import React, { useState, useEffect } from "react";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables";
import { Tabs, Tab } from "@appkit4/react-components/tabs";
import "../../../../../src/styles/userManagement.css";
import Planning from '../ViewWorkProgram'
import Table from '../../../Common/CommonTable'

export default function WorkProgram() {
  const [currentTab, setCurrentTab] = useState("1");
  const [createTab, setCreateTab] = useState(true);

  const handleTabs = (e, v) => {
    setCurrentTab(v);
  };
  const data2 = [
    {
      "id": "1",
      "AssessmentID": "TP910",
      "Status": "Recurring",
      "Name": "James",
      "Criticality": "Tier-1",
      "Assessor Name": "Smith",
      "Last Assessment Status": "Open",
      "Contact": "James Bare",
      "email": "test@emal.com",
      "ReviewStatus": "Pending",
      "category": "Service",
      "AssessmentType": "self",
      "Date": "2-04-2021"

    },
    {
      "id": "2",
      "AssessmentID": "TP789",
      "Status": "Recurring",
      "Name": "Rambabu",
      "Criticality": "Tier-1",
      "Assessor Name": "Smith",
      "Last Assessment Status": "Close",
      "Contact": "Raju",
      "email": "test@emal.com",
      "ReviewStatus": "Pending",
      "category": "Service",
      "AssessmentType": "self",
      "Date": "2-04-2021"
    },
    {
      "id": "3",
      "AssessmentID": "TP112",
      "Status": "Off-boarding",
      "Name": "Ram",
      "Criticality": "Tier-2",
      "Assessor Name": "Smith",
      "Last Assessment Status": "Close",
      "Contact": "James B",
      "email": "test@emal.com",
      "ReviewStatus": "Pending",
      "category": "Service",
      "AssessmentType": "self",
      "Date": "2-04-2021"
    },
    {
      "id": "4",
      "AssessmentID": "TP456",
      "Status": "New",
      "Name": "Nagaraj",
      "Criticality": "Tier-3",
      "Assessor Name": "David",
      "Last Assessment Status": "Open",
      "Contact": "Gloden Smith",
      "email": "test@emal.com",
      "ReviewStatus": "Pending",
      "category": "Service",
      "AssessmentType": "self",
      "Date": "2-04-2021"
    },
    {
      "id": "5",
      "AssessmentID": "TP123",
      "Status": "New",
      "Name": "James",
      "Criticality": "Tier-2",
      "Assessor Name": "Smith",
      "Last Assessment Status": "Expired",
      "Contact": "John",
      "email": "test@emal.com",
      "ReviewStatus": "Pending",
      "category": "Service",
      "AssessmentType": "self",
      "Date": "2-04-2021"
    },
  ]
  $(document).on("click", "[id*='create_']", function () {
    setCreateTab(false);
  });
  const handleBack = () => {
    setCreateTab(true);
  }

  // useEffect(() => { }, []);
  // $(document).ready(function () {
  //   $('#tblInitiateSelf').DataTable({
  //     "scrollX": true, "initComplete": function (settings, json) {
  //       $('.dataTables_scrollBody thead tr').css({ visibility: 'collapse' });
  //     }, data: data2,
  //     destroy: true,
  //     info: false,
  //     language: {
  //       paginate: {
  //         next: '&gt;', // or '→'
  //         previous: '&lt;' // or '←' 
  //       }
  //     },
  //     fields: [
  //       {
  //         label: "Assessment ID:",
  //         name: "Assessment ID",
  //       },
  //       {
  //         label: "Status",
  //         name: "Status",
  //       },
  //       {
  //         label: "Third Party Name:",
  //         name: "Third Party Name",
  //       },
  //       {
  //         label: "Criticality:",
  //         name: "Criticality",
  //       },
  //       {
  //         label: "Assessor Name:",
  //         name: "Assessor Name",
  //       },
  //       {
  //         label: "Last Assessment status:",
  //         name: "Last Assessment status",
  //       },
  //       {
  //         label: "Third Party Contact:",
  //         name: "Third Party Contact",
  //       },

  //     ],
  //     columns: [
  //       { data: "AssessmentID" },
  //       { data: "Name" },
  //       { data: "Status" },
  //       { data: "Criticality" },
  //       { data: "Assessor Name" },
  //       {
  //         render: function (data, type, row) {

  //           let stylesClass
  //           switch (row["Last Assessment Status"]) {
  //             case "Expired":
  //               stylesClass = "Expired-status";
  //               break;
  //             case "Open":
  //               stylesClass = "Open-status";
  //               break;
  //             case "Close":
  //               stylesClass = "Close-status";
  //               break;
  //             default:
  //               stylesClass = "";
  //           }
  //           return (
  //             `<div class="bia-status ${stylesClass}">${row["Last Assessment Status"]}</div>`
  //           )
  //         }
  //       },
  //       { data: "Name" },
  //       { data: "email" },
  //       { data: "category" },
  //       { data: "AssessmentType" },
  //       { data: "Date" },
  //       { data: "ReviewStatus" },
  //       { data: "ReviewStatus" },
  //       {
  //         render: function (data, type, row) {
  //           return (
  //             '<span class="appkiticon icon-view-fill pointer view-fnt" title="view" id="create_' +
  //             row.vendor_id +
  //             '"></span>'
  //           );
  //         },
  //         orderable: false
  //       },
  //     ]
  //   });
  // });
  return (
    <div className="App">
      <div className="user-management-container">
        <Tabs
          defaultValue={currentTab}
          value={currentTab}
          onChange={handleTabs}
          className="a-tab-item-padding-10"
        >
          <Tab value="1" label="Work Program">
            {createTab ?
              <div className="col-lg-12 mt-3 pl-1">
                <div className="">
                  <Table id="tblInitiateSelf"
                    columns={[
                      "Assessment ID",
                      "Third Party Name",
                      "Status",
                      "Criticality",
                      "Assessor Name",
                      "Last Assessment status",
                      "Third Party Contact",
                      "Third Party Email",
                      "Category Of Third Party",
                      "Assessment Type",
                      "Next Assessment Date",
                      "Third Party Response Status",
                      "Third Party Review Status",
                      "Action"
                    ]}
                  />
                </div>
              </div>
              :
              <Planning handleBack={handleBack} />}
          </Tab>
        </Tabs>
      </div>
    </div>
  )
};
